import { render, staticRenderFns } from "./ReportPatrimony.vue?vue&type=template&id=141b3bc2&"
import script from "./ReportPatrimony.vue?vue&type=script&lang=js&"
export * from "./ReportPatrimony.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports